import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "helmop-values-tab-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { "data-testid": "helmop-values-tab" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-15" }
const _hoisted_6 = {
  key: 0,
  class: "yaml-form-controls"
}
const _hoisted_7 = { class: "mb-20" }

import { ref, nextTick } from 'vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import ButtonGroup from '@shell/components/ButtonGroup';
import YamlEditor from '@shell/components/YamlEditor';
import FleetValuesFrom from '@shell/components/fleet/FleetValuesFrom.vue';

import type { ButtonGroupOption } from '@shell/types/components/buttonGroup';

interface HelmOpResource {
  spec: { helm: { valuesFrom?: unknown } };
  metadata: { namespace: string };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpValuesTab',
  props: {
    value: {},
    mode: {},
    realMode: {},
    chartValues: {},
    chartValuesInit: {},
    yamlForm: {},
    yamlFormOptions: {},
    yamlDiffModeOptions: {},
    isYamlDiff: { type: Boolean },
    editorMode: {},
    diffMode: {},
    isRealModeEdit: { type: Boolean },
    hideTitle: { type: Boolean, default: false },
    isSuseAppCollection: { type: Boolean, default: false },
    bgBorder: { type: Boolean, default: false },
    hideBanner: { type: Boolean, default: false },
    compact: { type: Boolean }
  },
  emits: ["update:yaml-form", "update:chart-values", "update:diff-mode"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const yaml = ref<{ refresh?:() => void } | null>(null);

const refreshYaml = () => {
  nextTick(() => {
    yaml.value?.refresh?.();
  });
};

__expose({ refreshYaml });

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const updateYamlForm = () => {
  emit('update:yaml-form');
};

const updateChartValues = (value: string) => {
  emit('update:chart-values', value);
};

const updateDiffMode = (value: string) => {
  emit('update:diff-mode', value);
};

const updateValuesFrom = (valuesFrom: unknown) => {
  props.value.spec.helm.valuesFrom = valuesFrom;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('fleet.helmOp.values.descriptionCompact')), 1))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      (!__props.hideBanner)
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "info",
            class: "description mt-0",
            "label-key": __props.isSuseAppCollection ? 'fleet.helmOp.values.appCoDescription' : 'fleet.helmOp.values.description',
            "data-testid": "helmop-values-info-banner"
          }, null, 8, ["label-key"]))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (!__props.hideTitle)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)('fleet.helmOp.values.title')), 1))
        : _createCommentVNode("", true),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("div", _hoisted_5, [
        (__props.isRealModeEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(ButtonGroup), {
                value: __props.yamlForm,
                "inactive-class": "bg-disabled btn-sm",
                "active-class": "bg-primary btn-sm",
                options: __props.yamlFormOptions,
                "onUpdate:value": updateYamlForm
              }, null, 8, ["value", "options"]),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "yaml-form-controls-spacer" }, "\n           \n          ", -1)),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (__props.isYamlDiff)
                ? (_openBlock(), _createBlock(_unref(ButtonGroup), {
                    key: 0,
                    value: __props.diffMode,
                    options: __props.yamlDiffModeOptions,
                    "inactive-class": "bg-disabled btn-sm",
                    "active-class": "bg-primary btn-sm",
                    "onUpdate:value": updateDiffMode
                  }, null, 8, ["value", "options"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createVNode(_unref(YamlEditor), {
          ref_key: "yaml",
          ref: yaml,
          class: _normalizeClass({ 'bg-border': __props.bgBorder }),
          value: __props.chartValues,
          mode: __props.mode,
          "initial-yaml-values": __props.chartValuesInit,
          scrolling: true,
          "editor-mode": __props.editorMode,
          "hide-preview-buttons": true,
          "data-testid": "helmop-values-yaml-editor",
          "onUpdate:value": updateChartValues
        }, null, 8, ["class", "value", "mode", "initial-yaml-values", "editor-mode"])
      ]),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FleetValuesFrom, {
          value: __props.value.spec.helm.valuesFrom,
          namespace: __props.value.metadata.namespace,
          mode: __props.realMode,
          compact: __props.compact,
          "data-testid": "helmop-values-from",
          "onUpdate:value": updateValuesFrom
        }, null, 8, ["value", "namespace", "mode", "compact"])
      ])
    ])
  ]))
}
}

})